import { render } from "./MaterialsCommon.vue?vue&type=template&id=f33ae7de&scoped=true"
import script from "./MaterialsCommon.vue?vue&type=script&lang=js"
export * from "./MaterialsCommon.vue?vue&type=script&lang=js"

import "./MaterialsCommon.vue?vue&type=style&index=0&id=f33ae7de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33ae7de"]])

export default __exports__